const Gate = {

    // FIELDS
    "premise": "Premise",
    "gate_name": "Gate Name",
    "in_gate": "In Gate",
    "out_gate": "Out Gate",
    "all_users_allowed": "All Users Allowed",
    "is_residents_allowed": "Is Residents Allowed",
    "is_staff_allowed": "Is Staff Allowed",
    "is_vendor_allowed": "Is Vendor Allowed",
    "search": "Search",

    // PAGE HEADER
    "gate": "Gate",
    "qr": "QR",

    // ERROR
    "error_premise": "Select Premise",
    "error_gate_name": "Enter Gate Name",
    "error_in_gate": "Select In Gate",
    "error_out_gate": "Select Out Gate",
    "error_all_users_allowed": "Select All Users Allowed",
    "error_is_residents_allowed": "Select Is Residents Allowed",
    "error_is_staff_allowed": "Select Is Staff Allowed",
    "error_is_vendor_allowed": "Select Is Vendor Allowed",

    // TABLE HEADER
    "table_premise": "PREMISE",
    "table_name": "GATE NAME",
    "table_in_gate": "IN GATE",
    "table_out_gate": "OUT GATE",
    "table_all_users_allowed": "ALL USERS ALLOWED",
    "table_is_residents_allowed": "IS RESIDENTS ALLOWED",
    "table_is_staff_allowed": "IS STAFF ALLOWED",
    "table_is_vendor_allowed": "IS VENDOR ALLOWED",
}

export default Gate;